import instance, { formDataInstance } from "./baseRequest";

export const socialMediaLinksApi = {
  getAll: () => instance.get("/contact/social-media-links"),
  create: (formData) =>
    formDataInstance.post("/contact/social-media-links", formData),
  update: (id, formData) =>
    formDataInstance.put(`/contact/social-media-links/${id}`, formData),
  remove: (id) => instance.delete(`/contact/social-media-links/${id}`),
};
